import { render, staticRenderFns } from "./LearnerObservationList.vue?vue&type=template&id=12f4caf7"
import script from "./LearnerObservationList.vue?vue&type=script&lang=js"
export * from "./LearnerObservationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports